module.exports = __webpack_public_path__ + "static/media/mbys_cov_19_tes.de86ad1a.png";